import React from "react";
// @ts-ignore
import Modal from "react-modal";
const { forwardRef, useImperativeHandle } = React;

interface Props {
  modalTitle: string;
  heading: string;
  body: any;
  removePic: () => void;
}

interface Refs {
  openModal(): void;
  hideDelete(): void;
}

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    zIndex: "99",
    transform: "translate(-50%, -50%)",
  },
};

const ImageModal = forwardRef<Refs, Props>((props, ref) => {
  let modal: any = {};
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [hideDeleteVal, setHideDelete] = React.useState(false);

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // modal.style.color = "#f00";
  }

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  function deleteAction() {
    setIsOpen(false);
    props.removePic();
  }

  function hideDelete() {
    setHideDelete(true);
  }

  useImperativeHandle(ref, () => ({
    openModal() {
      openModal();
    },

    closeModal() {
      closeModal();
    },

    hideDelete() {
      hideDelete();
    },
  }));

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel={props.modalTitle}
        ariaHideApp={false}
      >
        <div className="rs-modal-header">
          <button
            className={`rs-modal-header-close rs-btn-close ${
              hideDeleteVal ? "" : ""
            }`}
            onClick={closeModal}
          >
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              fill="currentColor"
              aria-hidden="true"
              focusable="false"
              className="rs-icon"
              aria-label="close"
              data-category="application"
            >
              <path d="M2.784 2.089l.069.058 5.146 5.147 5.146-5.147a.5.5 0 01.765.638l-.058.069L8.705 8l5.147 5.146a.5.5 0 01-.638.765l-.069-.058-5.146-5.147-5.146 5.147a.5.5 0 01-.765-.638l.058-.069L7.293 8 2.146 2.854a.5.5 0 01.638-.765z"></path>
            </svg>
          </button>
        </div>
        <div>{props.body}</div>
        {!hideDeleteVal ? (
          <button
            className="modal-btn rs-btn-sm rs-btn-primary rs-btn-red"
            onClick={deleteAction}
          >
            Delete
          </button>
        ) : (
          ""
        )}
      </Modal>
    </div>
  );
});

export default ImageModal;
